import { render, staticRenderFns } from "./account_header.vue?vue&type=template&id=76e68744&scoped=true&"
import script from "./account_header.vue?vue&type=script&lang=js&"
export * from "./account_header.vue?vue&type=script&lang=js&"
import style0 from "./account_header.vue?vue&type=style&index=0&id=76e68744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e68744",
  null
  
)

export default component.exports